// upsell matrix
const upsellMatrix = {
    "16-rolls": {
        handle: "16-rolls-4-boxes",
        replace_in_cart: true,
    },
    "32-rolls": {
        handle: "32-rolls-8-boxes",
        replace_in_cart: true,
    },
    "96-rolls": {
        handle: "12-boxes",
        replace_in_cart: false,
    },
    "32-rolls-ca": {
        handle: "32-rolls-8-boxes-ca",
        replace_in_cart: true,
    },
    "96-rolls-ca": {
        handle: "12-boxes-ca",
        replace_in_cart: false,
    }
}

// print price ($51.27 = 5127)
function price(amount) {
    let total = Math.round((parseFloat(amount) / 100));
    return `$${total}`;
}

/***************************************** Slidshow *****************************/

// slideshow
new Swiper("#productSwiper", {
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: '#productSwiperRight,#productSwiperNext',
        prevEl: '#productSwiperLeft',
    },
    pagination: {
        el: '#productSwiperPagination',
        clickable: true
    },
    on: {
        slideChangeTransitionEnd: function () {
            if (document.querySelector(".swiper-slide-active.white")) {
                document.querySelector(".site-header").classList.add("white");
            } else {
                document.querySelector(".site-header").classList.remove("white");
            }
        }
    },
})

/***************************************** Subscribe /Buy Once *****************************/

// subscribe or buy once change event
document.querySelectorAll(".productFormRadioInput").forEach(function (element) {
    element.addEventListener("change", function () {
        // sync action across all forms
        document.querySelectorAll(`.productFormRadioInput[value="${this.value}"]`).forEach(element => {
            // check this
            element.checked = true;

            // update atc lang
            updateATCButton();

            if (this.value == "Subscribe") {
                // hide frequency selector
                document.querySelectorAll(".productFormFrequency").forEach(element => {
                    element.classList.add("active");
                })
            } else {
                // show frequency selector
                document.querySelectorAll(".productFormFrequency").forEach(element => {
                    element.classList.remove("active");
                })
            }
        })
    });
})

/***************************************** Rolls *****************************/

// rolls change event
document.querySelectorAll(".productFormRollsItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // change active product form
        this.closest(".productForm").classList.remove("active");
        document.querySelector(`.productForm[variant="${this.getAttribute("variant")}"]`).classList.add("active");
        updateATCButton();
    });
})

/***************************************** Frequency *****************************/

// frequency open
document.querySelectorAll(".productFormFrequencySelectLabel").forEach(function (element) {
    element.addEventListener("click", function () {
        this.classList.add("active");
    })
});

// frequency close
document.querySelector("body").addEventListener("click", function (e) {
    let activeSelect = document.querySelector(".productFormFrequencySelectLabel.active");
    if (activeSelect && !e.target.closest(".productFormFrequencySelectLabel.active")) {
        activeSelect.classList.remove("active");
    }
});

// frequency change
document.querySelectorAll(".productFormFrequencySelectOption").forEach(function (element) {
    element.addEventListener("click", function () {
        this.closest(".productFormFrequency").setAttribute("selling_plan", this.getAttribute("selling_plan"))
        this.parentElement.parentElement.querySelector(".productFormFrequencySelectLabel").innerHTML = this.innerHTML;
    });
})

// frequency setup
// popular is the default
document.querySelectorAll(".productFormFrequencySelectOption span.popular").forEach(function (element) {
    element.click();
})


/**************************************** ATC *************************************/

function updateATCButton() {
    // change verbiage
    if (document.querySelector(`.productFormRadioInput[value="Subscribe"]:checked`)) {
        document.querySelector("#productATC").textContent = "Subscribe";
    } else {
        document.querySelector("#productATC").textContent = "Add to Cart";
    }

    // check if sold out
    if (document.querySelector(".productForm.active.available")) {
        document.querySelector("#productATC").classList.remove("disabled");
    } else {
        document.querySelector("#productATC").classList.add("disabled");
    }
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

document.querySelector("#productATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // collect formdata
    let formData = {
        id: parseInt(document.querySelector(".productForm.active").getAttribute("variant")),
        quantity: 1
    };

    // Subscription
    if (document.querySelector(`.productFormRadioInput[value="Subscribe"]:checked`)) {
        formData.selling_plan = parseInt(document.querySelector(".productForm.active .productFormFrequency").getAttribute("selling_plan"))
    }

    this.classList.add("loading");

    // clear cart
    await fetch("/cart/clear.js");

    // add to cart
    await addProduct(formData);

    // stop loading
    this.classList.remove("loading");

    // current product
    const currentProduct = variantIDToProduct[formData.id];

    // upsell product
    const upsellProduct = variantIDToProduct[handleToVariantID[upsellMatrix[currentProduct.handle].handle]];

    // update box count (ugly)
    document.querySelector("#upsellDescriptionBoxCount").textContent = upsellProduct.title.replace("PlantPaper", "").replace("16", "").replace("32", "").replace("96", "").replace("Rolls", "").replace("-", "").replace("+", "").replace("Tissues", "").trim().toLowerCase();

    // update display price based on 1) are we replacing the current product in the cart 2) are we adding a subscription
    if (upsellMatrix[currentProduct.handle].replace_in_cart) {
        if (!!formData.selling_plan) {
            document.querySelector("#upsellDescriptionBoxPrice").textContent = price(upsellProduct.variants[0].selling_plan_allocations[0].per_delivery_price - currentProduct.variants[0].selling_plan_allocations[0].per_delivery_price);
        } else {
            document.querySelector("#upsellDescriptionBoxPrice").textContent = price(upsellProduct.variants[0].price - currentProduct.variants[0].price);
        }
    } else {
        if (!!formData.selling_plan) {
            document.querySelector("#upsellDescriptionBoxPrice").textContent = price(upsellProduct.variants[0].selling_plan_allocations[0].per_delivery_price);
        } else {
            document.querySelector("#upsellDescriptionBoxPrice").textContent = price(upsellProduct.variants[0].price);
        }
    }

    // update button label
    if (!!formData.selling_plan) {
        document.querySelector("#upsellATC").textContent = "Add Tissue to my subscription";
    } else {
        document.querySelector("#upsellATC").textContent = "Add Tissue to my order";
    }

    // open upsell
    openUpsell();

});

/*********************************** Stars *************/

document.querySelector("#productStars").addEventListener("click", function () {
    document.querySelector("#yotpo").scrollIntoView({
        behavior: "smooth"
    })
});

/***************************************** Tissues ***********************/

// start slider
new Swiper("#upsellSwiper", {
    slidesPerView: "auto",
    autoplay: {delay: 2000},
    loop: true,
    pagination: {
        el: '#upsellSwiperPagination',
        clickable: true
    }
})

// open upsell
function openUpsell() {
    if (window.innerWidth <= 800) {
        document.querySelector("body").classList.add("noScroll");
        document.querySelector("#upsell").showModal();
    } else {
        document.querySelector("#upsell").classList.add("active");
    }
}

// close upsell
function closeUpsell() {
    if (window.innerWidth <= 800) {
        document.querySelector("body").classList.remove("noScroll");
        document.querySelector("#upsell").close();
    } else {
        document.querySelector("#upsell").classList.remove("active");
    }
}

// close from back arrow
document.querySelector("#upsellBack").addEventListener("click", function (e) {
    closeUpsell();
})

// close from exit button
document.querySelector("#upsellExit").addEventListener("click", function (e) {
    closeUpsell();
    window.location.href = "/cart";
})

// upsell add to cart event
document.querySelector("#upsellATC").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");

    // get the active variant id of the main product
    const variantID = parseInt(document.querySelector(".productForm.active").getAttribute("variant"));

    // current product
    const currentProduct = variantIDToProduct[variantID];

    // upsell product
    const upsellProduct = variantIDToProduct[handleToVariantID[upsellMatrix[currentProduct.handle].handle]];

    // check if we should clear the cart
    if (upsellMatrix[currentProduct.handle].replace_in_cart) {
        await fetch("/cart/clear.js");
    }

    // check if we're adding a subscription
    const isSubscription = document.querySelector(`.productFormRadioInput[value="Subscribe"]:checked`);

    // check which bundle we're adding
    let sellingPlanID = null;
    if (isSubscription) {
        // find the frequency
        const frequency = document.querySelector(".productForm.active .productFormFrequency span").textContent.toLowerCase();

        // find the selling plan id
        upsellProduct.selling_plan_groups[0].selling_plans.forEach(plan => {
            if (plan.name.toLowerCase().includes(frequency.toLowerCase())) {
                sellingPlanID = plan.id;
            }
        });

        // if we didn't find a selling plan id, alert and exit
        if (!sellingPlanID) {
            alert("Error adding to cart, please contact info@plantpaper.us with this error message C2");
            throw new Error();
        }
    }

    // add to cart
    await addProduct({
        id: upsellProduct.variants[0].id,
        quantity: 1,
        selling_plan: sellingPlanID
    });

    // stop loading
    this.classList.remove("loading");

    window.location.href = "/cart";
});